const API_BASE_URL = process.env.REACT_APP_API_URL;
const FORGOT_PASSWORD_ENDPOINT = `${API_BASE_URL}auth/solicitar-cambio-contrasena`;
const VALIDATE_CODE_ENDPOINT = `${API_BASE_URL}auth/validar-codigo`;
const RESET_PASSWORD_ENDPOINT = `${API_BASE_URL}auth/establecer-contrasena`;

export const solicitarCambioContrasena = async (email) => {
  try {
    const response = await fetch(FORGOT_PASSWORD_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('Error al solicitar el cambio de contraseña.');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Error al solicitar el cambio de contraseña.');
  }
}; 

export const validarCodigo = async (credentials) => {
  try {
    const response = await fetch(VALIDATE_CODE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      throw new Error('Error al validar el código.');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Error al validar el código.');
  }
};

export const resetearContrasena = async (token, nuevaContrasena) => {
  try {
    const response = await fetch(RESET_PASSWORD_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ NuevaContrasena: nuevaContrasena }),
    });

    if (!response.ok) {
      // Intentar leer el cuerpo del error para más detalles
      const errorData = await response.json().catch(() => null); // Intenta parsear JSON, si falla, devuelve null
      const errorMessage = errorData?.message || `Error ${response.status} al resetear la contraseña.`;
      throw new Error(errorMessage);
    }

    // Si la respuesta es OK pero no hay cuerpo JSON (ej. 204 No Content)
    if (response.status === 204) {
        return { success: true, message: "Contraseña actualizada exitosamente." };
    }

    const data = await response.json();
    return { ...data, success: true }; // Asumimos éxito y mezclamos con cualquier dato devuelto

  } catch (error) {
    // Asegurarse de que error.message sea una cadena
    throw new Error(error.message || 'Error desconocido al resetear la contraseña.');
  }
};
